import { Card, CardContent } from "../../../shared/components/ui/Card";
import { Box, Typography, useTheme } from "@mui/material";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

interface EventsByMonthBarChartProps {
  eventsByMonth: { month: string; count: number }[];
}

function formatMonth(month: string) {
  // Ex: "2025-08" => "08/2025"
  const [year, m] = month.split("-");
  return `${m}/${year}`;
}

export function EventsByMonthBarChart({ eventsByMonth }: EventsByMonthBarChartProps) {
  const theme = useTheme();

  const data = {
    labels: eventsByMonth.map(e => formatMonth(e.month)),
    datasets: [
      {
        label: "Eventos",
        data: eventsByMonth.map(e => Number(e.count)),
        backgroundColor: theme.palette.primary.main,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false, labels: { color: theme.palette.text.primary } },
      title: { display: false },
      tooltip: {
        backgroundColor: theme.palette.background.paper,
        titleColor: theme.palette.text.primary,
        bodyColor: theme.palette.text.primary,
      },
    },
    scales: {
      x: {
        ticks: { color: theme.palette.text.primary },
        grid: { color: theme.palette.divider },
      },
      y: {
        beginAtZero: true,
        ticks: { color: theme.palette.text.primary },
        grid: { color: theme.palette.divider },
      },
    },
  };

  return (
    <Card sx={{ minHeight: 320 }}>
      <CardContent>
        <Typography variant="subtitle1" fontWeight={600} mb={1}>
          Eventos por Mês
        </Typography>
        <Box height={300}>
          <Bar data={data} options={options} />
        </Box>
      </CardContent>
    </Card>
  );
}